export default {
    // --------Title--------
    injectionFields: '注入参数字段',
    newInjectionField: '添加注入参数字段',
    properties: '属性',
    detailOfTheInjectionFields: '注入参数详细信息',

    // --------MUI--------
    mainProperty: '主要属性',
    module: '模块',
    reference: '参考',
    fieldType: '类型',
    fieldKey: '属性键',
};